import { clasolSuiteApi } from '../axiosConfig'
import { buildListParams, withSuiteAdminCode } from '../apiHelpers'

export const getUsers = async (params) => {
  const { data } = await clasolSuiteApi.get('/users', {
    params: buildListParams(params),
    ...withSuiteAdminCode(),
  })
  return data
}

export const getUser = async (id) => {
  const { data } = await clasolSuiteApi.get(`/users/${encodeURIComponent(id)}`, withSuiteAdminCode())
  return data
}

export const createUser = async (user) => {
  const { data } = await clasolSuiteApi.post('/users', user, withSuiteAdminCode())
  return data
}

export const updateUser = async (id, user) => {
  const { data } = await clasolSuiteApi.patch(`/users/${encodeURIComponent(id)}`, user, withSuiteAdminCode())
  return data
}

export const deleteUser = async (id) => {
  await clasolSuiteApi.delete(`/users/${encodeURIComponent(id)}`, withSuiteAdminCode())
}
